export class ReleaseNote {
    id?: number;
    description: string = '';
    releaseDate?: Date;
    published: boolean = false;
    appVersion: string = '';
    content: string = '';
}
